export const popover = {
  root: {
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    color: "{overlay.popover.color}",
    borderRadius: "{overlay.popover.border.radius}",
    shadow: "{overlay.popover.shadow}",
    gutter: "10px",
    arrowOffset: "32px",
  },
  content: {
    padding: "{overlay.popover.padding}",
  },
  css: (): string => `
    .p-popover {
      max-width: 90vw;
    }

    .p-popover-content {
      max-height: 80vh;
      overflow-y: auto;
    }
  `,
};
